<div class="status-container">
  <div [ngClass]="statusClass" data-type="job-status"> {{ userStatus }}</div>
</div>
